document.addEventListener('DOMContentLoaded', function () {
  const progressItems = document.querySelectorAll('.dw-progress');

  if (!progressItems.length) return;

  const animateProgress = function (item) {
    const target = parseInt(item.getAttribute('data-percent'), 10);
    const circle = item.querySelector('.dw-ring-fill');
    const count = item.querySelector('.dw-count');

    if (!circle || !count || isNaN(target)) return;

    const radius = 58;
    const circumference = 2 * Math.PI * radius;

    circle.style.strokeDasharray = circumference;
    circle.style.strokeDashoffset = circumference;

    const duration = 1400;
    const startTime = performance.now();

    function update(now) {
      const progress = Math.min((now - startTime) / duration, 1);
      const current = Math.round(progress * target);

      count.textContent = current;

      const offset = circumference - ((progress * target) / 100) * circumference;
      circle.style.strokeDashoffset = offset;

      if (progress < 1) {
        requestAnimationFrame(update);
      }
    }

    requestAnimationFrame(update);
  };

  const observer = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        animateProgress(entry.target);
        obs.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.35
  });

  progressItems.forEach(function (item) {
    observer.observe(item);
  });
});